<template>
  <div class="top-logo">
    <img src="@/assets/img/logo.png" alt="" width="26" />&nbsp;&nbsp;&nbsp;
    <span v-show="!collapse">华燕拆车</span>
    <!-- <div style="text-align: center">
     报废机动车回收拆解<br/>管理系统
    </div> -->
  </div>
</template>
<script>
export default {
  computed: {
    collapse() {
      return this.$store.state.IsCollapse;
    },
  },
};
</script>

<style>
</style>